<script setup lang="ts">
withDefaults(defineProps<{
	selected?: boolean;
}>(), {
	selected: false,
});
</script>

<template>
	<button
		class="py-1 px-3 rounded-full text-base leading-none font-medium text-white max-w-md text-opacity-50 cursor-pointer border hover:border-[#A09EB8] transition-all ease-in-out bg-primary-300"
		:class="{ 'text-opacity-100 border border-[#A09EB8]': selected, 'text-opacity-50 border-transparent': !selected }"
		type="button"
	>
		<slot />
	</button>
</template>
